/**
 * Bandeau visuel "STAGING" — s'affiche uniquement si VITE_API_URL contient "staging"
 * Rien a retirer pour la prod : le bandeau ne s'affiche tout simplement pas.
 * Affiche la DATE DE BUILD (heure Martinique, injectee par vite.config define) :
 * permet de verifier d'un coup d'oeil quelle version du bundle l'appareil sert.
 */
const isStaging = (import.meta.env.VITE_API_URL || '').includes('staging')
// eslint-disable-next-line no-undef
const buildDate = typeof __BUILD_DATE__ !== 'undefined' ? __BUILD_DATE__ : ''

export default function StagingBanner() {
  if (!isStaging) return null

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: 'linear-gradient(90deg, #f59e0b, #f97316)',
      color: '#fff',
      textAlign: 'center',
      padding: '4px 0',
      fontSize: '11px',
      fontWeight: 700,
      letterSpacing: '2px',
      textTransform: 'uppercase',
      pointerEvents: 'none',
    }}>
      STAGING — environnement de test{buildDate ? ` · build ${buildDate}` : ''}
    </div>
  )
}
